import i18n from './config';

const RTL_LANGUAGES = ['ar', 'he', 'fa'];

export const isRTL = (language: string): boolean => {
  return RTL_LANGUAGES.includes(language);
};

export const setDocumentDirection = (language: string): void => {
  document.documentElement.dir = isRTL(language) ? 'rtl' : 'ltr';
  document.documentElement.lang = language;
};

// Set up language change listener
i18n.on('languageChanged', (lng) => {
  setDocumentDirection(lng);
});

// Set initial direction
setDocumentDirection(i18n.language);
